module.exports = __webpack_public_path__ + "static/contact-us-banner-2-b09f53bda3ce6a71d390d1ee97fb1201.png";